import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";
import ComapreItemCard from "../../components/compare/CompareItemCard";
import { useDispatch, useSelector } from "react-redux";
import EmptyComponentRender from "../../components/EmptyComponentRender";
import {
  setCompareList,
  removeItemFromCompareList,
} from "../../redux/reducers/comparesList.reducer";
import firebase from "firebase";
import ConfirmationDialog from '../../components/ConfirmationDialog'
import { toast as Toast } from "react-toastify";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import {isMobile} from "react-device-detect";
const styles = {
  content: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    marginTop: 30,
    marginLeft: 20,
    marginRight: 20,
  },
  mainContainer: {
    padding: 20,
    /// paddingTop: StatusBar.currentHeight
  },
};

export default function ComparesListScreen() {
  const [loading, setLoading] = useState(false);
  const [itemToDelete, setItemToDelete] = useState();
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [isInitiated, setIsInitiated] = useState(false);
  const list = useSelector((state) => state.comparesList.comparesList);
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const theme = useTheme();
  const userInfo = useSelector((state) => state.auth.user);
  const initCompareList = () => {
    console.log("ini")
    if (userInfo && userInfo.id) {
      setLoading(true);
      setIsInitiated(true);
      firebase
        .firestore()
        .collection("users")
        .doc(userInfo.id)
        .collection("compares")
        .get()
        .then((comapres) => {
          console.log("compares array : ",comapres)
          if (comapres && comapres.docs && comapres.docs.length > 0) {
            dispatch(setCompareList(comapres.docs.map((item) => item.data())));
            setLoading(false);
          } else {
            dispatch(setCompareList([]));
            setLoading(false);
          }
        })
        .catch((err) => {
          console.log(err);
          dispatch(setCompareList([]));
          setLoading(false);
        });
    }
  };
  const handleClearCart = (itemToDelete) => {
    setItemToDelete(itemToDelete);
    setShowConfirmationDialog(true);
}
  const handleDelete = () => {
    const id = itemToDelete;
    setLoading(true);
    if (userInfo && userInfo.id && id && !loading) {
      firebase
        .firestore()
        .collection("users")
        .doc(userInfo.id)
        .collection("compares")
        .doc(id)
        .delete()
        .then((res) => {
          dispatch(removeItemFromCompareList(id));
          Toast.success("Item Deleted :)");
          setItemToDelete();
          setShowConfirmationDialog(false);
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setItemToDelete();
          setShowConfirmationDialog(false);
          Toast.error("Couldn't item :(");
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    
      initCompareList();
    
  }, []);

  return (
    <div style={{ flex: 1, backgroundColor: theme.light.white }}>
    <div className={styles.mainContainer}>
      <div className={styles.content}>
      <ConfirmationDialog visible={showConfirmationDialog} title={'cart.clearCartTitle'} body={'cart.clearCartBody'} hideDialog={() => setShowConfirmationDialog(false)} confirmCb={handleDelete} />
      {list && list?.length > 0 ? (        
      <Grid container spacing={4} style={{ display: "flex", flexWrap: "wrap", padding:20, paddingTop:isMobile?60:20}}>
        
          {list.map((item, index) => (
            <ComapreItemCard
              id={item.id}
              handleDelete={()=>handleClearCart(item.id)}
              loading={loading}
              count={item.count}
              key={index}
              title={item.title ? item.title :i18n.language == "ar" ? item.titleAr : item.titleEn}
            />
          ))}
        
            </Grid>
             ): (
                <EmptyComponentRender />
              )}
              
      </div>
    </div>
    </div>
  );
}
